export const fuseUserNavigationConfig = [
    {
        'id': 'application',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
            {
                'id': 'dashboard',
                'title': 'Dashboard',
                'type': 'item',
                'icon': 'dashboard',
                'url': '/apps/dashboards/admin'
            },
        ]
    }
];


// WEBPACK FOOTER //
// ./src/fuse-configs/fuseUserNavigationConfig.js